export default __webpack_public_path__ + "static/media/hht2_ani_02.2888d758.png";